import { Section } from "../components/Section"

const bibTex = "@inproceedings{yang2026lingoq,<br/>\n\
&emsp;&emsp;title={LingoQ: Bridging the Gap between EFL Learning and Work through AI-Generated Work-Related Quizzes},<br/>\n\
&emsp;&emsp;author={Yeonsun Yang and Sang Won Lee and Jean Y. Song and Sangdoo Yun and Young-Ho Kim},<br/>\n\
&emsp;&emsp;year = {2026},<br/>\n\
&emsp;&emsp;publisher = {Association for Computing Machinery},<br/>\n\
&emsp;&emsp;address = {New York, NY, USA},<br/>\n\
&emsp;&emsp;url = {https://doi.org/10.1145/3772318.3791342},<br/>\n\
&emsp;&emsp;doi = {10.1145/3772318.3791342},<br/>\n\
&emsp;&emsp;booktitle = {Proceedings of the 2026 CHI Conference on Human Factors in Computing Systems},<br/>\n\
&emsp;&emsp;location = {Yokohama, Japan},<br/>\n\
&emsp;&emsp;series = {CHI '26}<br/>\n\
}"

export const Cite = () => {
    return <Section title="Citing This Work">
        <div className="border-y-2 border-purple-500/30 py-3">
            <div>Yeonsun Yang, Sang Won Lee, Jean Y. Song, Sangdoo Yun, and Young-Ho Kim. 2026.</div>
            <div className="font-bold">LingoQ: Bridging the Gap between EFL Learning and Work through AI-Generated Work-Related Quizzes.</div>
            <div>In CHI Conference on Human Factors in Computing Systems (CHI ’26)</div>
            <div>https://doi.org/10.1145/3772318.3791342</div>
        </div>
        <div className="mt-4">
            <div className="font-bold mb-1">BibTeX</div>
            <p className={"p-3 font-mono text-xs sm:text-sm border-2 rounded-lg border-purple-500/30 decoration-none"} dangerouslySetInnerHTML={{__html: bibTex}}/>
        </div>
        
    </Section>
}